module.exports = __webpack_public_path__ + "static/media/prick_HMPG_header_image_02_1400.cfc9a098.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/prick_HMPG_header_image_02_1400.jpg
// module id = 353
// module chunks = 0